import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/director-board")({
  component: () => <Outlet />,
});
